import React, { type FC } from 'react'
import { Box } from '@mui/material'

import type { BufferType } from '../../../../domain'

import type { BaseCommonProps } from '../Base'
import { Dropdown } from '../Dropdown'
import { useBufferTypeTranslator } from './Hooks'

type Props = Readonly<{ value: BufferType, types: readonly BufferType[], onChange: (value: BufferType) => void }> & Pick<BaseCommonProps, 'sx'>

export const BufferTypeSelect: FC<Props> = ({ value, types, onChange, sx }) => {
    const translate = useBufferTypeTranslator()

    if (types.length < 2) {
        /**
         * No real choice is possible, give up
         */
        return null
    }

    const bufferOptions = types.map((type) => ({ value: type, label: translate(type) })).sort(({ label: a }, { label: b }) => b.localeCompare(a))

    return (
        <Box sx={sx}>
            <Dropdown<BufferType>
                buttonLabel={translate(value)}
                options={bufferOptions}
                size="medium"
                data-testid="buffer-type-select"
                value={value}
                onChange={onChange}
            />
        </Box>
    )
}
